
import React from "react";
import { Link } from "react-router-dom";
import { Plus, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

interface BikesHeaderProps {
  onRefresh: () => void;
}

const BikesHeader: React.FC<BikesHeaderProps> = ({ onRefresh }) => {
  const handleRefresh = () => {
    onRefresh();
    toast.success("Bike list refreshed");
  };

  return (
    <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
      <h1 className="text-3xl font-bold tracking-tight">eBikes</h1>
      <div className="flex gap-2">
        <Button variant="outline" size="sm" onClick={handleRefresh}>
          <RefreshCw className="h-4 w-4" />
          Refresh
        </Button>
        <Button asChild>
          <Link to="/bikes/new">
            <Plus className="mr-2 h-4 w-4" />
            Add New eBike
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default BikesHeader;
